"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPORT_PRIORITY_TASKS = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.EXPORT_PRIORITY_TASKS = (0, gql_1.gql)(`
  mutation ExportPriorityTasks($input: ExportPriorityTasksInput!) {
    exportPriorityTasks(input: $input) {
      totalRows
      expiresAt
      downloadUrl
      clientMutationId
      error
    }
  }
`);
